const key = (assistantId: string) => `agent-tests:last-set:${assistantId}`;

export function rememberSet(assistantId: string, testSetId: string): void {
  try {
    window.localStorage.setItem(key(assistantId), testSetId);
  } catch {
    // Storage can be blocked; the default falls back to the first set.
  }
}

export function lastSet(assistantId: string): string | null {
  try {
    return window.localStorage.getItem(key(assistantId));
  } catch {
    return null;
  }
}
